import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { useGetInvestmentFundQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import TunnelManagement from './tunnels/TunnelManagement';
import TunnelMenu from './tunnels/TunnelMenu';
import TunnelActiveVersion from './tunnels/TunnelActiveVersion';
import { ListContainer } from 'components';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import * as icons from 'mdi-material-ui';

const tabKeys = {
    CONTROL: 'control',
    FORM: 'form',
    ACTIVE_VERSION: 'active_version',
};

const Tunnels = () => {
    const { fundId } = useParams();
    const { data: fund } = useGetInvestmentFundQuery(fundId, { skip: !fundId });

    const [tab, setTab] = useState(tabKeys.CONTROL);

    const handleTabChange = useCallback(newTab => {
        setTab(newTab);
    }, []);

    return (
        <ListContainer>
            <Breadcrumbs separator={<icons.MenuRight />} aria-label="breadcrumb">
                <Link
                    underline="hover"
                    href="/fund-management"
                    to="/fund-management"
                    component={RouterLink}
                >
                    {texts.FUND}
                </Link>
                {fundId ? (
                    <Link
                        underline="hover"
                        href={`/fund-management/${fundId}/tunnels`}
                        to={`/fund-management/${fundId}/tunnels`}
                        component={RouterLink}
                    >
                        {texts.TUNNEL_VERSIONS} - {fund?.name}
                    </Link>
                ) : (
                    <Typography>{texts.CREATE_INVESTMENT_FUND}</Typography>
                )}
            </Breadcrumbs>
            {tab === tabKeys.CONTROL && (
                <TunnelMenu
                    onManage={() => handleTabChange(tabKeys.FORM)}
                    onShowActiveVersion={() => handleTabChange(tabKeys.ACTIVE_VERSION)}
                />
            )}
            {tab === tabKeys.FORM && (
                <TunnelManagement onCancel={() => handleTabChange(tabKeys.CONTROL)} />
            )}
            {tab === tabKeys.ACTIVE_VERSION && (
                <TunnelActiveVersion onCancel={() => handleTabChange(tabKeys.CONTROL)} />
            )}
        </ListContainer>
    );
};

export default Tunnels;
